import { useState } from 'react';
import { useQuery, useQueries } from '@tanstack/react-query';
import ButtonSpinnerDarkIcon from '../../svgs/ButtonSpinnerDark.svg?react';
import { FormError, HelpText } from '@Forms/fields.jsx';
import { imageQuery } from '../../queries/queries.js';

const setSelectedImage = (props, image) => {
  props.watch(props.name);
  props.setValue(props.name, image);
  props.setValue(`${props.name}_id`, props.choice.val);
};

const ImageItem = (props) => {
  const { data: imageData, isPending: imageIsPending } = useQuery(
    imageQuery(props.choice.val),
  );

  return (
    <>
      {imageIsPending && <ButtonSpinnerDarkIcon />}
      {imageData && imageData.sizes && (
        <button
          className={
            `sb-form-item-imageselect-menuitem st-img-clip` +
            (props.currentValue == props.choice.val
              ? ' sb-form-item-imageselect-active'
              : '')
          }
          onClick={() => setSelectedImage(props, imageData.absolute_path)}
          type="button"
        >
          <img
            src={`/${imageData.sizes.medium}`}
            style={{ maxWidth: '100px' }}
          />
        </button>
      )}
      {!imageIsPending && !imageData && (
        <div className="sb-form-item-imageselect-menuitem st-img-clip">
          <p>Unable to display image</p>
        </div>
      )}
    </>
  );
};

const ImageSelectField = (props) => {
  const queries = props.choices
    ? props.choices.map((choice, index) => imageQuery(choice.val))
    : [];

  const queryResults = useQueries({ queries: queries });

  let selectedImageURL;

  if (queryResults) {
    const selectedImage = queryResults.find(
      (queryResult) =>
        queryResult &&
        queryResult.data &&
        queryResult.data.id == props.currentValue,
    );
    // Match might not have data, such as in the case of a 403 error
    if (selectedImage && selectedImage.data) {
      selectedImageURL = `/${selectedImage.data.sizes.medium}`;
    }
  }

  const imagesList = props.choices
    ? props.choices.map((choice, index) => {
        return (
          <ImageItem
            choice={choice}
            currentValue={props.currentValue}
            key={`${props.name}.${index}`}
            label={props.label}
            name={props.name}
            register={props.register}
            setValue={props.setValue}
            watch={props.watch}
          />
        );
      })
    : [];

  return (
    <div
      className={
        `sb-form-item-formgroup sb-form-item-image-select ` +
        (props.error ? 'sb-form-item-error' : '')
      }
    >
      <div className="sb-form-item-label">{props.label}</div>
      <div className="sb-form-item-content sb-form-item-imageselect">
        <div className="sb-form-item-imageselect-window">
          {selectedImageURL && (
            <>
              <span className="sb-selected-img-title">Selected Image:</span>
              <img src={selectedImageURL}></img>
            </>
          )}
          {!selectedImageURL && (
            <>
              <span className="sb-selected-img-title">Selected Image:</span>
              <div className="sb-selected-no-image">
                <p>Click a thumbnail to select an image</p>
              </div>
            </>
          )}
        </div>
        <div className="sb-form-item-imageselect-menu">{imagesList}</div>
        <input
          defaultValue={props.currentValue}
          type="hidden"
          {...props.register(props.name, props.options)}
        />
      </div>
      {props.helpText && <HelpText message={props.helpText} />}
      {props.error && <FormError message={props.error.message} />}
    </div>
  );
};

export default ImageSelectField;
